// src/data/patientNotificationsMockData.js

export const notificationsMockData = [
  {
    id: 1,
    title: 'Appointment Reminder',
    description:
      'Your consultation with Dr. Anjali Verma is scheduled for tomorrow at 10:00 AM.',
    type: 'Appointment',
    date: '2024-08-12',
    read: false,
  },
  {
    id: 2,
    title: 'Payment Confirmation',
    description:
      'Your payment of ₹1500 for the consultation with Dr. Rajesh Kumar has been successfully processed.',
    type: 'Payment',
    date: '2024-08-11',
    read: true,
  },
  {
    id: 3,
    title: 'New Message from Dr. Shubham',
    description:
      'Dr. Shubham has sent you a new message regarding your recent lab results. Please check the message.',
    type: 'Message',
    date: '2024-08-10',
    read: false,
  },
  {
    id: 4,
    title: 'Medication Refill Reminder',
    description:
      'It’s time to refill your prescription for Sertraline. Please contact your pharmacy.',
    type: 'Appointment',
    date: '2024-08-09',
    read: true,
  },
  {
    id: 5,
    title: 'Follow-up Consultation Available',
    description:
      'A follow-up consultation slot is available with Dr. Pooja Sharma. Book your appointment now.',
    type: 'Appointment',
    date: '2024-08-08',
    read: false,
  },
  {
    id: 6,
    title: 'Lab Results Ready',
    description:
      'Your lab results from the tests conducted on 2024-08-01 are now available. Please view them online.',
    type: 'Appointment',
    date: '2024-08-07',
    read: false,
  },
  {
    id: 7,
    title: 'New Article: Managing Anxiety',
    description:
      'Dr. Ritu Jain has published a new article on managing anxiety during stressful times. Read now!',
    type: 'Message',
    date: '2024-08-06',
    read: true,
  },
  {
    id: 8,
    title: 'Insurance Claim Processed',
    description:
      'Your insurance claim for the recent consultation has been processed. The amount of ₹1200 will be credited to your account.',
    type: 'Payment',
    date: '2024-08-05',
    read: true,
  },
  {
    id: 9,
    title: 'Therapy Session Reminder',
    description:
      'Your therapy session with Dr. Ananya is scheduled for 2024-08-14 at 4:00 PM.',
    type: 'Appointment',
    date: '2024-08-04',
    read: false,
  },
  {
    id: 10,
    title: 'New Message from Clinic',
    description:
      'The clinic has sent you a new message regarding your upcoming consultation.',
    type: 'Message',
    date: '2024-08-03',
    read: false,
  },
  {
    id: 11,
    title: 'Payment Due Reminder',
    description:
      'You have a pending payment of ₹500 for your last session with Dr. Rahul Mehta. Please clear the dues to avoid late fees.',
    type: 'Payment',
    date: '2024-08-02',
    read: true,
  },
  {
    id: 12,
    title: 'Exercise Routine Update',
    description:
      'Your personalized exercise routine has been updated based on your recent consultation.',
    type: 'Message',
    date: '2024-08-01',
    read: true,
  },
];
